<script setup lang="ts">
import { computed } from 'vue'

type NotificationStatus = 'error' | 'warning' | 'success'

interface Props {
  /** The status type of the notification */
  status: NotificationStatus
}

const { status } = defineProps<Props>()

defineOptions({
  name: 'BaseNotificationPanel'
})

const iconName = computed(() => {
  if (status === 'error') {
    return '$alert-circle-outline'
  }

  if (status === 'warning') {
    return '$information-outline'
  }

  return '$check-circle-outline'
})

const iconClasses = computed(() => {
  if (status === 'error') {
    return 'text-danger'
  }

  if (status === 'warning') {
    return 'text-warning'
  }

  return 'text-success'
})

const containerClasses = computed(() => {
  if (status === 'error') {
    return 'bg-danger-light border-danger'
  }

  if (status === 'warning') {
    return 'bg-warning-light border-warning'
  }

  return 'bg-success-light border-success'
})

const iconProps = computed(() => ({
  class: [iconClasses.value],
  icon: iconName.value
}))
</script>

<template>
  <div
    class="flex rounded-sm border border-l-4 py-6 pr-4"
    :class="[containerClasses]"
  >
    <div class="px-4">
      <VIcon v-bind="iconProps" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
